import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../../external-components/angular-material.module';
import { SharedModule } from '../shared/shared.module';
import { PipesModule } from '../../pipes/pipes.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CalibrationBalanceEditComponent } from './calibration/calibration-balance-edit/calibration-balance-edit.component';
import { CalibrationBalanceListComponent } from './calibration/calibration-balance-list/calibration-balance-list.component';
import { CalibrationBalanceListFilterComponent } from './calibration/calibration-balance-list/calibration-balance-list-filter.component';
import { CalibrationBalanceEditConfirmSaveComponent } from './calibration/calibration-balance-edit-confirm-save-component/calibration-balance-edit-confirm-save.component';
import { CalibrationBalanceEditConfigDialogComponent } from './calibration/calibration-balance-edit-config-dialog-component/calibration-balance-edit-config-dialog.component';
import { CalibrationBalanceEditPatternsDialogComponent } from './calibration/calibration-balance-edit-patterns-dialog/calibration-balance-edit-patterns-dialog.component';
import { CalibrationBalanceEditCreateEquipmentComponent } from './calibration/calibration-balance-edit-create-equipment/calibration-balance-edit-create-equipment.component';
import { CalibrationBalanceEditAsLeftDialogComponent } from './calibration/calibration-balance-edit-as-left-dialog/calibration-balance-edit-as-left-dialog.component';
import { CalibrationBalanceEditSelectPointsComponent } from './calibration/calibration-balance-edit-select-points/calibration-balance-edit-select-points.component';
import { CalibrationBalanceEditAsFoundDialogComponent } from './calibration/calibration-balance-edit-as-found-dialog/calibration-balance-edit-as-found-dialog.component';
import { CalibrationBalanceEditGenerateReportComponent } from './calibration/calibration-balance-edit-generate-report/calibration-balance-edit-generate-report.component';
import { CalibrationBalanceEditAutomaticSignReportComponent } from './calibration/calibration-balance-edit-automatic-sign-report/calibration-balance-edit-automatic-sign-report.component';
import { CalibrationBalanceEditManualSignReportComponent } from './calibration/calibration-balance-edit-manual-sign-report/calibration-balance-edit-manual-sign-report.component';
import { CalibrationBalanceEditAuditComponent } from './calibration/calibration-balance-edit-audit/calibration-balance-edit-audit.component';

@NgModule({
  declarations: [CalibrationBalanceEditComponent, CalibrationBalanceListComponent, 
    CalibrationBalanceListFilterComponent, CalibrationBalanceEditConfirmSaveComponent, 
    CalibrationBalanceEditConfigDialogComponent, CalibrationBalanceEditPatternsDialogComponent, 
    CalibrationBalanceEditCreateEquipmentComponent, CalibrationBalanceEditAsLeftDialogComponent,
    CalibrationBalanceEditSelectPointsComponent, CalibrationBalanceEditAsFoundDialogComponent,
    CalibrationBalanceEditGenerateReportComponent, CalibrationBalanceEditAutomaticSignReportComponent,
    CalibrationBalanceEditManualSignReportComponent, CalibrationBalanceEditAuditComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    /* Custom modules */
    AngularMaterialModule,
    SharedModule,
    PipesModule,
    /* Otros */
    FlexLayoutModule,
    MatDatepickerModule, 
    MatMomentDateModule
  ],
  providers: [
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}}
  ],
  exports: [CalibrationBalanceEditComponent, CalibrationBalanceListComponent,
    CalibrationBalanceListFilterComponent, CalibrationBalanceEditConfirmSaveComponent, 
    CalibrationBalanceEditConfigDialogComponent, CalibrationBalanceEditPatternsDialogComponent,
    CalibrationBalanceEditCreateEquipmentComponent, CalibrationBalanceEditAsLeftDialogComponent, 
    CalibrationBalanceEditSelectPointsComponent, CalibrationBalanceEditAsFoundDialogComponent,
    CalibrationBalanceEditGenerateReportComponent, CalibrationBalanceEditAutomaticSignReportComponent,
    CalibrationBalanceEditManualSignReportComponent, CalibrationBalanceEditAuditComponent]
})
export class BalancesModule { }
